import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_auth/reports/my-approaching-statutes")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  useEffect(() => {
    void navigate({ to: "/", replace: true });
  }, [navigate]);

  return null;
}
